import Ajax from '@/api/ajax'

// 获取
export const getWxUrl = (data) => Ajax.request('/pension/common/wx/config', 'get', data, { showLoading: false })

export const getWxOpenId = (data) => Ajax.request('', 'post', data, { showLoading: false })

export const getWxUserInfo = (data) => Ajax.request('/frameworks/systems/user/login/wechat', 'post', data, { showLoading: false })
// 获取签名
export const getSignature = (data) => Ajax.request('/frameworks/systems/wechat/wechat/jsapi/sign', 'post', data, { showLoading: false })


export const security = (data) => Ajax.request('/frameworks/systems/user/security', 'get', data, { showLoading: false })
export const securityLoad = (data) => Ajax.request('/frameworks/systems/user/security', 'get', data, { showLoading: true })

export const userDetail = (data) => Ajax.request(`/business/user/uasUserDetail`, 'post', data, { showLoading: true })

